import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e26becf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-filter" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  class: "contents",
  ref: "scrollContainer"
}
const _hoisted_4 = {
  key: 0,
  class: "filter-container"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title",
  id: "campus-filter-title"
}, "캠퍼스", -1 /* HOISTED */))
const _hoisted_6 = {
  role: "group",
  "aria-labelledby": "campus-filter-title"
}
const _hoisted_7 = { class: "filter-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title",
  id: "date-filter-title"
}, "날짜", -1 /* HOISTED */))
const _hoisted_9 = {
  class: "date-filter-wrapper",
  role: "group",
  "aria-labelledby": "date-filter-title"
}
const _hoisted_10 = { class: "calendar-input-wrapper" }
const _hoisted_11 = {
  key: 1,
  class: "filter-container"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title",
  id: "line-type-filter-title"
}, "노선형태", -1 /* HOISTED */))
const _hoisted_13 = {
  role: "group",
  "aria-labelledby": "line-type-filter-title"
}
const _hoisted_14 = {
  key: 2,
  class: "filter-container"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title",
  id: "line-direction-filter-title"
}, "방향", -1 /* HOISTED */))
const _hoisted_16 = {
  role: "group",
  "aria-labelledby": "line-direction-filter-title"
}
const _hoisted_17 = {
  key: 3,
  class: "filter-container"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title",
  id: "location-filter-title"
}, "지역", -1 /* HOISTED */))
const _hoisted_19 = {
  role: "group",
  "aria-labelledby": "location-filter-title"
}
const _hoisted_20 = { class: "filter-container" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-space" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], {
      title: "필터",
      shouldHideBackButton: true,
      onOnClickClose: $setup.emitOnClickClose
    }, {
      rightButton: _withCtx(() => [
        _createElementVNode("button", {
          class: "reset-btn",
          type: "button",
          disabled: $setup.apiParams === $setup.defaultApiParams,
          onClick: $setup.resetFilter
        }, " 초기화 ", 8 /* PROPS */, _hoisted_2)
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_3, [
      ($setup.campusFilter && $setup.visibleFilters.has('campusCodes'))
        ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode($setup["LineSearchFilterItems"], {
                filter: $setup.campusFilter,
                selectedOptions: $setup.getSelectedOptions($setup.campusFilter),
                onOnClickOption: $setup.updateFilter
              }, null, 8 /* PROPS */, ["filter", "selectedOptions"])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("section", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode($setup["CustomSelect"], {
            class: "select-container",
            filter: $setup.dateFilter,
            onOnSelectOption: $setup.handleClickDateFilter,
            "aria-label": "날짜 종류 선택"
          }, null, 8 /* PROPS */, ["filter"]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode($setup["TargetCalendarInput"], {
              disabled: $setup.isCalendarDisabled,
              selectedDate: 
                $setup.getSelectedOptionsStr($setup.dateFilter, $setup.dateFilter.selectedOptions)
              ,
              onOnSelectDate: _cache[0] || (_cache[0] = ($event: any) => ($setup.updateDateFilter($event, $setup.dateFilter))),
              "aria-label": "달력 열기"
            }, null, 8 /* PROPS */, ["disabled", "selectedDate"])
          ])
        ])
      ]),
      _createCommentVNode(" <section\n        v-if=\"bookFilter && bookRequiredType === BookRequiredType.MIXED\"\n        class=\"filter-container\"\n      >\n        <p class=\"title\" id=\"book-filter-title\">예약</p>\n        <div role=\"group\" aria-labelledby=\"book-filter-title\">\n          <LineSearchFilterItems\n            :filter=\"bookFilter\"\n            :selectedOptions=\"getSelectedOptions(bookFilter)\"\n            @onClickOption=\"updateFilter\"\n          />\n        </div>\n      </section> "),
      ($setup.lineTypeFilter && $setup.visibleFilters.has('lineTimeCodes'))
        ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode($setup["LineSearchFilterItems"], {
                filter: $setup.lineTypeFilter,
                selectedOptions: $setup.getSelectedOptions($setup.lineTypeFilter),
                onOnClickOption: $setup.updateFilter
              }, null, 8 /* PROPS */, ["filter", "selectedOptions"])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      ($setup.lineDirectionFilter && $setup.visibleFilters.has('lineDirectionCodes'))
        ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createVNode($setup["LineSearchFilterItems"], {
                filter: $setup.lineDirectionFilter,
                selectedOptions: $setup.getSelectedOptions($setup.lineDirectionFilter),
                onOnClickOption: $setup.updateFilter
              }, null, 8 /* PROPS */, ["filter", "selectedOptions"])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      ($setup.locationFilter && $setup.visibleFilters.has('lineDistrictCodes'))
        ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createVNode($setup["LineSearchFilterItems"], {
                filter: $setup.locationFilter,
                selectedOptions: $setup.getSelectedOptions($setup.locationFilter),
                onOnClickOption: $setup.updateFilter
              }, null, 8 /* PROPS */, ["filter", "selectedOptions"])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" <section v-if=\"dayOfWeekFilter\" class=\"filter-container\">\n        <p class=\"title\">요일</p>\n        <LineSearchFilterItems\n          :filter=\"dayOfWeekFilter\"\n          :selectedOptions=\"getSelectedOptions(dayOfWeekFilter)\"\n          @onClickOption=\"updateFilter\"\n        />\n      </section> "),
      _createElementVNode("section", _hoisted_20, [
        _createVNode($setup["TimeSlider2"], {
          title: "시간",
          minHourRange: 0,
          maxHourRange: 24,
          step: 3,
          labelStep: 6,
          fromTimeFilter: $setup.fromTimeFilter,
          toTimeFilter: $setup.toTimeFilter,
          onOnUpdateFromTime: $setup.updateFromTimeFilter,
          onOnUpdateToTime: $setup.updateToTimeFilter
        }, null, 8 /* PROPS */, ["fromTimeFilter", "toTimeFilter"])
      ]),
      _hoisted_21,
      ($setup.scrollContainer)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 4,
            container: $setup.scrollContainer
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true)
    ], 512 /* NEED_PATCH */),
    _createVNode($setup["FooterButton"], {
      class: "footer-btn",
      title: "검색",
      onOnClickFooterButton: $setup.emitOnClickApplyBtn
    })
  ]))
}